<app-full-loading-indicator></app-full-loading-indicator>
<nav class="navbar navbar-expand-lg navbar-dark">

    <div class="container-fluid">

        <a class="ml-4 navbar-brand buttons" [style.visibility]="menuService.menuStatus ? 'hidden' : 'visible'"
            [routerLink]="['/']">{{title}}</a>

        <div class="ml-auto responsive-nav-info">
            <div class="container-fluid">
                <span class="navbar-text" *ngIf="authService.isLoggedIn">
                    <u style="cursor: pointer" class="mr-5" [routerLink]="['modulo-geral', 'alterar-empresa']">Empresa
                        Base: <span id="empresa_base_sigla">{{authService.company.siglaRelatorio}}</span></u>
                    {{authService.user.nome}}
                    (<u style="cursor: pointer" (click)="authService.logout()">Sair</u>)
                </span>
            </div>
        </div>

        <span class="navbar-text" *ngIf="!authService.isLoggedIn">
            <button class="btn btn-outline-success" [routerLink]="['login']">Login</button>
        </span>

        <ul class="navbar-nav me-auto mb-2 mb-lg-0" *ngIf="authService.isLoggedIn">
            <div id="mySidenav" class="sidenav" [style.width]="menuService.menuStatus ? '400px' : '0px'">
                <a href="javascript:void(0)" class="closebtn" (click)="ToggleMenu()">&times;</a>

                <div class="responsive-sidebar-info mx-auto w-100">
                    <div style="text-align: center" class="navbar-text font-weight-bold w-100"
                        *ngIf="authService.isLoggedIn">
                        <u style="cursor: pointer;" class="mr-5 text-decoration-none" (click)="ToggleMenu()"
                            [routerLink]="['modulo-geral', 'alterar-empresa']">
                            Empresa Base: <span>{{authService.company.siglaRelatorio}}</span>
                        </u>
                        <u style="cursor: pointer" (click)="authService.logout()"
                            class="text-decoration-none">{{authService.user.nome}}(Sair)</u>
                    </div>
                </div>

            </div>
        </ul>
    </div>
</nav>

<nav class="navbar navbar-expand-lg navbar-dark" style="background-color: #fff; height: 35px;"
    *ngIf="authService.isLoggedIn">
    <div class="container-fluid">
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                <li class="nav-item dropdown" *ngFor="let menu of authService.modules">
                    <a class="nav-link dropdown-toggle" [class.collapsed]="isCollapsed(menu.id, true)"
                        id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        {{menu.descMenu}}
                    </a>
                    <ul class="dropdown-menu" style="top: 34px;">
                        <ng-container *ngFor="let subItem of menu.itemsMenu">
                            <li class="nav-item dropend dropright">
                                <a class="dropdown-item dropdown-toggle"
                                    [class.collapsed]="isCollapsed(subItem.id, false)"
                                    (click)="toggle(subItem.id, false, false)" id="itemsDropdown" role="button"
                                    data-toggle="collapse" data-bs-toggle="dropdown" aria-expanded="false">
                                    {{subItem.descSubMenu}}
                                </a>
                                <ul class="dropdown-menu">
                                    <ng-container *ngFor="let item of subItem.itemsSubMenu">
                                        <li><a class="dropdown-item item" *ngIf="item.legacy"
                                                [routerLink]="['legacy', item.viewName]">{{item.descModulo}}</a></li>
                                        <li><a class="dropdown-item item" *ngIf="!item.legacy"
                                                [routerLink]="item.route">{{item.descModulo}}</a></li>
                                    </ng-container>
                                </ul>
                            </li>
                        </ng-container>
                    </ul>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" [class.collapsed]="isCollapsed(4, true)"
                        (click)="toggle(4, true, false)" id="navbarDropdown2" role="button" data-toggle="collapse"
                        data-bs-toggle="dropdown" aria-expanded="false">
                        Utilitários
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown2" style="top: 34px;">
                        <ng-container>
                            <li class="dropdown-header dropdown">
                                <a class="dropdown-item item " [routerLink]="['modulo-geral', 'alterar-senha']">
                                    Alterar Senha
                                </a>
                            </li>
                        </ng-container>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</nav>
